import { render, staticRenderFns } from "./shoppOrder.vue?vue&type=template&id=aa1fb85c&scoped=true"
import script from "./shoppOrder.vue?vue&type=script&lang=js"
export * from "./shoppOrder.vue?vue&type=script&lang=js"
import style0 from "./shoppOrder.vue?vue&type=style&index=0&id=aa1fb85c&prod&lang=scss&scoped=true"
import style1 from "./shoppOrder.vue?vue&type=style&index=1&id=aa1fb85c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1fb85c",
  null
  
)

export default component.exports